/**
 * All CustomEvent + bus event name constants. CSTS Cat-4.
 * No component may hardcode an event name string.
 */

export const EVENTS = {
  SCENE_CHANGED: "scene:changed",
  SESSION_STARTED: "session:started",
  SESSION_ITEM_SHOWN: "session:item-shown",
  SESSION_ANSWERED: "session:answered",
  SESSION_NEXT_ROUND: "session:next-round",
  SESSION_COMPLETE: "session:complete",
  MATCH_CORRECT: "game:match-correct",
  MATCH_WRONG: "game:match-wrong",
  ROUND_COMPLETE: "game:round-complete",
  FACT_CARD_SHOWN: "game:fact-card-shown",
  ACHIEVEMENT_UNLOCKED: "game:achievement-unlocked",
  INSTALL_PROMPT_AVAILABLE: "pwa:install-available",
  INSTALL_ACCEPTED: "pwa:install-accepted",
  INSTALL_DISMISSED: "pwa:install-dismissed",
  DOWNLOAD_STARTED: "pwa:download-started",
  SETTINGS_CHANGED: "settings:changed",
  THEME_CHANGED: "settings:theme-changed",
  LOCALE_CHANGED: "settings:locale-changed"
} as const;

export type GameEventName = (typeof EVENTS)[keyof typeof EVENTS];
